'use strict';
import * as $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal from "./com.raquo.airstream.common.-Single-Parent-Signal.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal from "./com.raquo.airstream.core.-Writable-Signal.js";
import * as $j_com$002eraquo$002eairstream$002emisc$002e$002dMap$002dSignal from "./com.raquo.airstream.misc.-Map-Signal.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_state_LazyStrictSignal(parentSignal, zoomIn, parentDisplayName, displayNameSuffix) {
  this.uR = null;
  this.uQ = false;
  this.uS = null;
  this.rC = 0;
  this.uO = null;
  this.uP = null;
  this.uV = false;
  this.rE = null;
  this.uT = false;
  this.rD = 0;
  this.rF = null;
  this.rG = null;
  this.rH = null;
  this.uU = 0;
  this.F6 = null;
  this.F5 = null;
  this.F4 = null;
  this.F6 = parentSignal;
  this.F5 = parentDisplayName;
  this.F4 = displayNameSuffix;
  $j_com$002eraquo$002eairstream$002emisc$002e$002dMap$002dSignal.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(this, parentSignal, zoomIn, $j_java$002elang$002e$002dObject.$m_s_None$());
}
export { $c_Lcom_raquo_airstream_state_LazyStrictSignal as $c_Lcom_raquo_airstream_state_LazyStrictSignal };
$p = $c_Lcom_raquo_airstream_state_LazyStrictSignal.prototype = new $j_com$002eraquo$002eairstream$002emisc$002e$002dMap$002dSignal.$h_Lcom_raquo_airstream_misc_MapSignal();
$p.constructor = $c_Lcom_raquo_airstream_state_LazyStrictSignal;
/** @constructor */
function $h_Lcom_raquo_airstream_state_LazyStrictSignal() {
}
export { $h_Lcom_raquo_airstream_state_LazyStrictSignal as $h_Lcom_raquo_airstream_state_LazyStrictSignal };
$h_Lcom_raquo_airstream_state_LazyStrictSignal.prototype = $p;
$p.dd = (function() {
  return (((("" + this.F5.h()) + this.F4) + "@") + $j_java$002elang$002e$002dObject.$systemIdentityHashCode(this));
});
$p.b3 = (function() {
  var newParentLastUpdateId = this.F6.gs();
  if ((newParentLastUpdateId !== this.rD)) {
    var nextValue = this.id();
    $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__updateCurrentValueFromParent__s_util_Try__I__V(this, nextValue, newParentLastUpdateId);
    return nextValue;
  } else {
    return $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
  }
});
$p.ll = (function(nextValue, nextParentLastUpdateId) {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__updateCurrentValueFromParent__s_util_Try__I__V(this, nextValue, nextParentLastUpdateId);
});
var $d_Lcom_raquo_airstream_state_LazyStrictSignal = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_state_LazyStrictSignal, "com.raquo.airstream.state.LazyStrictSignal", ({
  hi: 1,
  c2: 1,
  a1: 1,
  M: 1,
  ai: 1,
  ak: 1,
  au: 1,
  az: 1,
  as: 1,
  aQ: 1,
  aj: 1,
  ay: 1,
  b1: 1,
  c3: 1
}));
export { $d_Lcom_raquo_airstream_state_LazyStrictSignal as $d_Lcom_raquo_airstream_state_LazyStrictSignal };
